import { render } from "./CostByWsxy.vue?vue&type=template&id=fb376dc2&scoped=true"
import script from "./CostByWsxy.vue?vue&type=script&lang=js"
export * from "./CostByWsxy.vue?vue&type=script&lang=js"

import "./CostByWsxy.vue?vue&type=style&index=0&id=fb376dc2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-fb376dc2"

export default script